import Types from "../action/types"

export function data(state = {}, action = {}) {
    switch (action.type){

        case Types.FETCH_DATA:{
            const {uniqueId,data,error,} = action.payload;
            let _currentState = state[uniqueId] || {};
             _currentState = {..._currentState, data};
            return {
                ...state,
                [uniqueId]:{..._currentState,error}
            };
        }
        case Types.REMOVE_DATA:{
            const preState = {...state}
            const {uniqueId} = action.payload;
            delete preState[uniqueId];
            return preState;
        }
        case Types.SET_HEADER_TITLE:{
            return {...state, headerTitle: action.payload}
        }
        case Types.SAVE_DATA: {
            return {...state, homeData: action.payload}
        }
        default:
            return state
    }
}





// WEBPACK FOOTER //
// ./src/store/reducer/data.js